"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ipBan = require("@/api/ipBan");
var _permission = require("@/utils/permission");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IpAccessRule',
  data: function data() {
    return {
      activeTab: '1',
      listLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      searchForm: {
        ip: '',
        page: 1,
        limit: 20
      },
      dialogVisible: false,
      submitting: false,
      accessForm: {
        ip: '',
        banType: 'permanent',
        banSeconds: 3600,
        reason: ''
      },
      accessRules: {
        ip: [{
          required: true,
          message: '请输入IP地址',
          trigger: 'blur'
        }, {
          pattern: /^(\d{1,3}\.){3}\d{1,3}$/,
          message: '请输入合法的IP地址',
          trigger: 'blur'
        }],
        banSeconds: [{
          required: true,
          message: '请输入封禁时长',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:ip:ban:access:rule:list'])) this.loadList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    loadList: function loadList() {
      var _this = this;
      this.listLoading = true;
      (0, _ipBan.ipAccessRuleList)(_objectSpread(_objectSpread({}, this.searchForm), {}, {
        type: Number(this.activeTab)
      })).then(function (res) {
        _this.tableData = res;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleTabChange: function handleTabChange() {
      this.searchForm.page = 1;
      this.loadList();
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        ip: '',
        page: 1,
        limit: 20
      };
      this.loadList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.loadList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.loadList();
    },
    handleAdd: function handleAdd() {
      this.accessForm = {
        ip: '',
        banType: 'permanent',
        banSeconds: 3600,
        reason: ''
      };
      this.dialogVisible = true;
    },
    handleBanTypeChange: function handleBanTypeChange(val) {
      if (val === 'permanent') this.accessForm.banSeconds = 0;else this.accessForm.banSeconds = 3600;
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      var label = row.type === 1 ? '黑名单' : '白名单';
      this.$modalSure("\u786E\u8BA4\u79FB\u9664 ".concat(row.ip, " \u7684").concat(label, "\u8BB0\u5F55\uFF1F")).then(function () {
        (0, _ipBan.ipAccessRuleDelete)(row.id).then(function () {
          _this2.$message.success('移除成功');
          _this2.loadList();
        });
      });
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.accessForm.validate(function (valid) {
        if (!valid) return;
        _this3.submitting = true;
        var data = {
          ip: _this3.accessForm.ip,
          type: Number(_this3.activeTab),
          reason: _this3.accessForm.reason,
          banSeconds: _this3.activeTab === '1' ? _this3.accessForm.banType === 'permanent' ? 0 : _this3.accessForm.banSeconds : 0
        };
        (0, _ipBan.ipAccessRuleAdd)(data).then(function () {
          _this3.$message.success('添加成功');
          _this3.dialogVisible = false;
          _this3.loadList();
        }).finally(function () {
          _this3.submitting = false;
        });
      });
    },
    handleDialogClose: function handleDialogClose() {
      this.$refs.accessForm && this.$refs.accessForm.resetFields();
    }
  }
};